/**
 * 🔴 설계 해상도 단일 출처. 이 파일 밖 어디에도 해상도 숫자를 쓰지 않는다.
 *
 * CLAUDE.md 「레이아웃 정책」:
 *   - 고정 레이아웃이다. 미디어 쿼리로 배치를 바꾸지 않는다.
 *   - 뷰포트 맞춤은 transform: scale() 로 한다(와이어프레임 fit() 3058행과 같은 방식).
 *   - 대상은 12인치 태블릿. **실측 해상도는 아직 모른다.**
 *
 * 아래 값은 와이어프레임 실물(25–26행 `.frame{width:1440px;height:900px}`)에서 가져온
 * **잠정값**이다. eric 이 실측을 주면 이 상수만 바꾸면 끝난다.
 */
export const DESIGN_VIEWPORT = {
  width: 1440,
  height: 900,
} as const

export type DesignViewport = typeof DESIGN_VIEWPORT

/** 화면 맞춤 계산에 쓰는 좌우 여백(와이어프레임 fit() 의 -32) */
export const DESIGN_VIEWPORT_MARGIN = 32

/**
 * 설계 해상도를 CSS 커스텀 프로퍼티로 흘린다.
 * CSS 쪽에도 숫자를 두지 않으려는 것이다 — 출처는 위 상수 하나뿐이다.
 */
export function applyDesignViewport(root: HTMLElement): void {
  root.style.setProperty('--design-w', `${DESIGN_VIEWPORT.width}px`)
  root.style.setProperty('--design-h', `${DESIGN_VIEWPORT.height}px`)
}

/**
 * 뷰포트 폭에 맞춘 축소 배율. 확대는 하지 않는다(최대 1).
 * 실제 scale 적용 컴포넌트는 셸 작업에서 붙인다 — 여기서는 계산만 제공한다.
 */
export function fitScale(viewportWidth: number): number {
  const usable = viewportWidth - DESIGN_VIEWPORT_MARGIN
  return Math.min(1, Math.max(0, usable / DESIGN_VIEWPORT.width))
}
